import { useQuery } from '@tanstack/react-query'
import { StorageKey } from '@/client/types'
import { getCountries } from '@/infra/services'

export const useGetCountries = (locale: string = 'en') =>
  useQuery([StorageKey.LOCATIONS, locale], () => getCountries(locale), { refetchOnWindowFocus: false })
